var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('svg',{staticClass:"icon back",attrs:{"aria-hidden":"true"},on:{"click":_vm.back}},[_c('use',{attrs:{"xlink:href":"#icon-xiaoyuhao"}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }